@import '~style-sheet-helpers/core.less';

.edit-tag-modal {
  width: 445px;
}

.modal-body {
  padding: 15px;
}

.loading-indicator {
  padding: 0 10px;
  height: 50px;
}

.modal-footer {
  > button {
    margin-left: 10px;
  }
}
